<template>
  <div class="relative t3m-ImageMap isolate">
    <t3m-video v-if="backgroundUrl" />
    <t3m-hotspots v-if="hotspots.length"
                  @seek="seek" />
    <t3m-modal v-if="status === 'wait'" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import t3mHotspots from "@/components/t3mHotspots/";
import t3mModal from "@/components/t3mModal/";
import t3mVideo from "@/components/t3mVideo/";
import { createStore } from "./store";

export default {
  name: "App",
  components: {
    t3mVideo,
    t3mHotspots,
    t3mModal,
  },
  computed: {
    ...mapState(["backgroundUrl", "hotspots", "status"]),
  },
  beforeCreate: function () {
    this.$store = createStore();
  },
  mounted() {
    let api;
    if (process.env.NODE_ENV === "development") {
      api = process.env.VUE_APP_API;
    } else if (process.env.NODE_ENV === "production") {
      api = this.$el.closest('.t3m-Section--imagemap').dataset.api;
    }

    this.$store.dispatch("loadAllData", api);
  },
  methods: {
    ...mapActions(["setStatus"]),
    seek: function (payload) {
      // console.log("got seek");
    },
    leave: function () {
      this.setStatus("leave");
    },
  },
};
</script>
